import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelComponent } from './components/transport-options-panel/transport-options-panel.component';
import { TransportOptionEntryComponent } from './components/transport-option-entry/transport-option-entry.component';
import { TransportOptionParameterComponent } from './components/transport-option-parameter/transport-option-parameter.component';
import { TransportOptionParameterSelectionComponent } from './components/transport-option-parameter-selection/transport-option-parameter-selection.component';



@NgModule({
  declarations: [
    TransportOptionsPanelComponent,
    TransportOptionEntryComponent,
    TransportOptionParameterComponent,
    TransportOptionParameterSelectionComponent,
    TransportOptionParameterComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  exports: [
    TransportOptionsPanelComponent

  ]
})
export class TransportOptionsPanelModule { }
